/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Where_LabelInputs */

const en_directory_search_where_label = /** @type {(inputs: Directory_Search_Where_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where?`)
};

const pl_directory_search_where_label = /** @type {(inputs: Directory_Search_Where_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdzie?`)
};

/**
* | output |
* | --- |
* | "Where?" |
*
* @param {Directory_Search_Where_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_where_label = /** @type {((inputs?: Directory_Search_Where_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Where_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_where_label(inputs)
	return en_directory_search_where_label(inputs)
});